import {ReactElement, useMemo} from "react";
import {RendererProps} from "../RendererProps";
import {Account} from "../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import {ensureNotObject, formatBudgetYearAndVersionType, keyify} from "../common";
import {MinimalProperty} from "../../../../../contexts/properties/logic";
import * as common from "../styles/common.module.scss";

export interface RenderSubmitCopyDriversProps extends RendererProps {
    accounts: Account[];
    properties: MinimalProperty[];
}

export function RenderSubmitCopyDrivers(props: RenderSubmitCopyDriversProps): ReactElement {
    const period = props.variables["period"];
    const accountIds = props.variables["accountIds"];
    const budgetYear = props.variables["budgetYear"];
    const copyAssumptions = props.variables["copyAssumptions"];
    const sourcePropertyId = props.variables["sourcePropertyId"];
    const destinationPropertyIds = props.variables["destinationPropertyIds"];

    const accountMap = useMemo(() => {
        return props.accounts.toIdMap(a => a.id);
    }, [props.accounts]);

    const propertyMap = useMemo(() => {
        return props.properties.toIdMap(p => p.id);
    }, [props.properties]);

    let sourceType: string | null = null;
    let destType: string | null = null;
    if(typeof period === "object") {
        sourceType = period["sourceVersionType"];
        destType = period["destinationVersionType"];
    }

    const accountNames: ReactElement[] = [];
    if(Array.isArray(accountIds)) {
        for(const accountId of accountIds) {
            const account = accountMap[accountId];
            if(account) {
                accountNames.push(<li key={keyify(account.id)}>{ensureNotObject(account.name)}</li>);
            }
        }
    }

    let sourceProperty: MinimalProperty | undefined = undefined;
    if(typeof sourcePropertyId === "string") {
        sourceProperty = propertyMap[sourcePropertyId];
    }

    let destinationProperties: (MinimalProperty | undefined)[] = [undefined];
    if(Array.isArray(destinationPropertyIds)) {
        destinationProperties = destinationPropertyIds.map(id => typeof id === "string" ? propertyMap[id] : undefined);
    }

    return <div>
        <div className={common.textHeader}>{formatBudgetYearAndVersionType(budgetYear, sourceType)} -&gt; {formatBudgetYearAndVersionType(budgetYear, destType)}</div>
        <div className={common.section}>
            <div>Accounts</div>
            <ul>{accountNames}</ul>
        </div>
        {copyAssumptions && <div className={common.section}>Assumptions Copied</div>}
        <div className={common.section}>Source Property: {sourceProperty?.name || "Unknown"}</div>
        <div className={common.section}>Destination Properties: {destinationProperties.map(p => p?.name ?? "Unknown").join(", ")}</div>
    </div>;
}